export function fenToYuan(fen) {
	return (Number(fen || 0) / 100).toFixed(2)
}

export function yuanToFen(yuan) {
	return Math.round(parseFloat(yuan) * 100)
}

export function apiMsg(res, fallback) {
	return (res && res.data && (res.data.msg || res.data.message)) || fallback || '操作失败'
}

export function formatEntryDiscount(val) {
	var num = Number(val)
	if (isNaN(num)) {
		return '--'
	}
	if (num > 10) {
		return (num / 100).toFixed(2)
	}
	return String(num)
}

export function formatCompositeDiscount(val) {
	var num = Number(val)
	if (isNaN(num)) {
		return '--'
	}
	var zhe = num / 100
	var text = zhe % 1 === 0 ? String(zhe) : String(parseFloat(zhe.toFixed(2)))
	return text + '折'
}

export function itemCompositeCost(item) {
	if (!item) {
		return 0
	}
	if (item.composite_cost != null && item.composite_cost !== '') {
		return Number(item.composite_cost)
	}
	return Number(item.unit_cost || 0)
}

export function itemCompositeDiscount(item) {
	if (!item) {
		return NaN
	}
	if (item.composite_discount != null && item.composite_discount !== '') {
		return Number(item.composite_discount)
	}
	return Number(item.discount)
}

export function formatMarkupDiscount(val) {
	var num = Number(val)
	if (isNaN(num)) {
		return '--'
	}
	if (num === 0) {
		return '不加价'
	}
	var zhe = num % 1 === 0 ? String(num) : String(parseFloat(num.toFixed(2)))
	return '+' + zhe + ' 折'
}



// WEBPACK FOOTER //
// ./src/components/buyer/warehouse/money.js